import React from 'react'
import { l } from '@manychat/manyui'

export const SmbAppDisconnected = () => {
  return (
    <span>
      {l.translate(
        'Your WhatsApp Business account has been deactivated and is no longer connected to Manychat',
      )}
    </span>
  )
}
